import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';

type Props = PropsWithChildren & {
  toggle:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'indigo'
    | 'purple'
    | 'orange'
    | 'teal'
    | 'pink';
  placement: 'top' | 'left' | 'right' | 'bottom';
  text: string;
  width?: 100 | 150 | 200 | 250 | 300 | 350 | 400 | 450 | 500;
};

export const Tooltip = ({
  children,
  toggle,
  placement,
  text,
  width,
}: Props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <div className="tooltip-component">
        <div
          className={clsx(
            'tooltip-component-inner',
            hovered && 'tooltip-component-show',
            `tooltip-component-${toggle}`,
            `tooltip-component-${placement}`,
            width ? `wd-${width}` : ''
          )}
          style={{ whiteSpace: 'pre-wrap', width: width ? '' : 'max-content' }}
        >
          {text}
        </div>
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="d-inline"
        >
          {children}
        </div>
      </div>
      {/* FIXME: refine */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .tooltip-component {
            display: inline;
            position: relative;
            margin: 0;
          }
          .tooltip-component-inner {
            position: absolute;
            z-index: 1070;
            margin: 0;
            padding: 0.5em 1em;
            border-radius: 5px;
            display: none;
            font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
            font-style: normal;
            font-weight: 400;
            line-height: 1.5;
            text-align: left;
            text-align: start;
            text-decoration: none;
            text-shadow: none;
            text-transform: none;
            letter-spacing: normal;
            word-break: normal;
            word-spacing: normal;
            white-space: normal;
            line-break: auto;
            font-size: 0.76562rem;
            word-wrap: break-word;
          }
          .tooltip-component-show {
            opacity: 0.9;
            display: block;
          }
          .tooltip-component-top {
            bottom: calc(100% + 5px);
            left: 50%;
            transform: translateX(-50%);
          }
          .tooltip-component-right {
            top: 50%;
            left: calc(100% + 5px);
            transform: translateY(-50%);
          }
          .tooltip-component-left {
            top: 50%;
            right: calc(100% + 5px);
            transform: translateY(-50%);
          }
          .tooltip-component-bottom {
            top: calc(100% + 5px);
            left: 50%;
            transform: translateX(-50%);
          }
          .tooltip-component-primary {
            background-color: #1b84e7;
            color: #fff;
          }
          .tooltip-component-secondary {
            background-color: #6c757d;
            color: #fff;
          }
          .tooltip-component-success {
            background-color: #23BF08;
            color: #fff;
          }
          .tooltip-component-warning {
            background-color: #F49917;
            color: #fff;
          }
          .tooltip-component-danger {
            background-color: #dc3545;
            color: #fff;
          }
          .tooltip-component-info {
            background-color: #5B93D3;
            color: #fff;
          }
          .tooltip-component-indigo {
            background-color: #6610f2;
            color: #fff;
          }
          .tooltip-component-purple {
            background-color: #6f42c1;
            color: #fff;
          }
          .tooltip-component-orange {
            background-color: #f27510;
            color: #fff;
          }
          .tooltip-component-teal {
            background-color: #1CAF9A;
            color: #fff;
          }
          .tooltip-component-pink {
            background-color: #e83e8c;
            color: #fff;
          }
        `,
        }}
      />
    </>
  );
};
